import * as commondata from "../Common";

export const bulkupdateData = {
  bulkUpdate: async (data) => {
    const apiurl = commondata.commonData().apiUrl;
    try {
      const response = await fetch(`${apiurl}tattle/bulk-update`, {
        method: "post",
        body: JSON.stringify(data),
      });
      const rdata = await response.json();
      return rdata;
    } catch (error) {
      console.log(error);
    }
  },
};
